import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import { css } from "styled-components";

headerStyles.invoiceCountGridItem = mergeToNew(headerStyles.invoiceCountGridItem, {
    width: [12, 12, 10, 11, 11],
});

headerStyles.toggleFilterGridItem = mergeToNew(headerStyles.toggleFilterGridItem, {
    width: [12, 12, 2, 1, 1],
    css: css`
        align-items: flex-end;
        align-items: center;
        gap: 16px;
        margin-top: 24px;
    `,
    style: { marginTop: "8px", justifyContent: "flex-end", alignItems: "flex-end" },
});

headerStyles.toggleFilterButton = mergeToNew(headerStyles.toggleFilterButton, {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        gap: 8px;
        color: ${themeColors.primary.richBlack};

        &,
        &:hover {
            border: none;
            background: transparent;
        }
    `,
});
